import { useFanPublicationStore } from "%/stores/fan-publication-store";
import { mapActions, mapState } from "pinia";
import { CHANNEL_CONTEXT, useChannelStore } from "~/stores/channel-store";
import { Enum, MenuConstants } from "@bloglovin/vue-component-library";
import { useChannelUserFeedStore } from "~/smart-feed/stores/feed/channel-user-feed-store";

export const ListOfChannelsElementMixin = {
  props: {
    visibilityType: {
      type: Enum,
      options: ["public", "exclusive"],
      default: "public",
    },
  },
  data() {
    return {
      isChannelDropdownOpen: false,
      channelName: "",
      visibility: "public",
      showCreateChannelModal: false,
      showGlobalNotificationSettingsModel: false,
    };
  },
  computed: {
    ...mapState(useFanPublicationStore, ["publicationId", "publicationName"]),
    ...mapState(useChannelStore, [
      "channels",
      "directMessageConversations",
      "isLoadingCreateChannel",
      "activeConversationId",
      "activeContext",
      "activeEntityId",
    ]),
    visibilityOptions() {
      return {
        public: [
          { label: `Public - Anyone in ${this.publicationName}`, value: "public" },
          { label: "Invite Only - Only specific people", value: "invite_only" },
        ],
        exclusive: [
          { label: "Exclusive - Subscribers only", value: "exclusive" },
          { label: "Invite Only - Only specific people", value: "exclusive_invite_only" },
        ],
      };
    },
    possibleVisibilityOptions() {
      return this.visibilityOptions[this.visibilityType];
    },
    channelDropdownItems() {
      const items = [];
      items.push({
        name: "Create Channel",
        label: "Create Channel",
        actionType: MenuConstants.ACTION_TYPE_BUTTON_CLICK,
        actionValue: "openCreateChannelModal",
      });

      return items;
    },
  },
  created() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    const conversationId = params.get("conversation_id");
    const context = params.get("context");
    const entityId = params.get("entity_id");

    if (context && conversationId && entityId) {
      this.switchActiveEntity(entityId, context, conversationId, true);
    } else {
      this.switchActiveEntity(this.activeEntityId, this.activeContext, this.activeConversationId, true);
    }

    window.addEventListener("popstate", event => {
      if (typeof event.state === "object") {
        if (event.state.entityId && event.state.context && event.state.conversationId) {
          this.switchActiveEntity(event.state.entityId, event.state.context, event.state.conversationId, false);
        }
      }
    });
  },
  methods: {
    ...mapActions(useChannelStore, [
      "fetchChannels",
      "createChannel",
      "switchToEntity",
    ]),
    // @todo we have conversation id because of dms which could have the same entityIds - until we have changed db
    switchActiveEntity(entityId, context, conversationId, updateHistoryState = true) {
      this.switchToEntity(entityId, context, conversationId, updateHistoryState);
      if (context === CHANNEL_CONTEXT) {
        useChannelUserFeedStore().reload();
      }
    },
    handleCreateChatroomChannel() {
      this.createChannel(this.channelName, "publication", this.publicationId, this.visibility, data => {
        this.channelName = "";
        this.visibility = this.visibilityOptions[this.visibilityType][0].value;
        this.showCreateChannelModal = false;
        this.switchToEntity(data.channel.channel_id, CHANNEL_CONTEXT, data.channel.conversation_id, true);
      });
    },
    openCreateChannelModal() {
      this.showCreateChannelModal = true;
    },
    openGlobalNotificationSettingsModel() {
      this.showGlobalNotificationSettingsModel = true;
    },
    handleChannelDropdownAction(action) {
      this[action]();
      this.isChannelDropdownOpen = false;
    },
    fetchPublicationChannels() {
      this.fetchChannels("publication", this.publicationId, this.visibilityType);
    },
  },
};
